/**溯源实例路由 */
export default [
    {
        name:'instance',
        path:'instance',
        meta: { title: '溯源实例' },
        component: ()=>import('@/pages/instance/index.vue')
    }
]